import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo } from '@/store/slices/userInfo.js';
import Icon from '@/assets/verify/icon.svg';
import './index.less';

export default function Verify({ setCurrentPage }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailcode, setEmailCode] = useState('');
  const [warningText, setWarningText] = useState('');
  const [emailcodeCheck, setEmailcodeCheck] = useState(false);
  const stateUserInfo = useSelector((state) => state.userInfo);

  // 用户输入code
  const handleInputCode = (val) => {
    setEmailcodeCheck(false);
    setWarningText('');
    setEmailCode(val.target.value);
    dispatch(setUserInfo({ key: 'emailCode', value: val.target.value }));
  };
  // 跳转注册页面
  const navigateToSetPassword = () => {
    window.onClickGATrackEvent('signup-verify-mailcode');
    if (!emailcode) {
      console.log('message提醒 请输入验证码');
      setWarningText('Please enter your email verification code');
      setEmailcodeCheck(true);
      return;
    }
    if (emailcode.length > 6) {
      console.log('message提醒 code个数超过6位了');
      return;
    }
    if (setCurrentPage) {
      setCurrentPage('setPassword');
      return;
    }
    navigate('/setPassword');
  };
  // 添加回车键盘监听
  useEffect(() => {
    const handleEnterPress = (e) => {
      if (e.key === 'Enter') {
        navigateToSetPassword();
      }
    };

    document.addEventListener('keydown', handleEnterPress);

    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailcode]);
  return (
    <div className="verifyBox">
      <img src={Icon} className="iocnlogo" alt="" />
      <div className="text">We’ve send an email to</div>
      <div className="text1">{stateUserInfo.userInfo.email}</div>
      <div className="text2">
        please check your mailbox and enter the verification code <br />
        The verification code is valid for 30 minutes
      </div>
      <div className="warning_text">{emailcodeCheck && warningText}</div>
      <input
        type="text"
        placeholder="code"
        onInput={handleInputCode}
        maxLength={6}
        className={`input input-bordered emailcode_ipt ${emailcodeCheck ? 'input-error' : ''}`}
      />
      <button className="btn btn-primary continue_btn" onClick={navigateToSetPassword}>
        Continue
      </button>
    </div>
  );
}
